import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import PrevArrowSVG from '../../components/SVG';
import NextArrowSVG from '../../components/SVG/NextArrowSVG';
import SingleServiceFive from '../../components/Service/SingleServiceFive';

import shapeImg from '../../assets/img/about/shape-2-1.png';
import serviceImg1 from '../../assets/img/service/case-1-1.jpg';
import serviceImg2 from '../../assets/img/service/case-1-2.jpg';
import serviceImg3 from '../../assets/img/service/case-1-3.jpg';
import serviceImg4 from '../../assets/img/service/case-1-4.jpg';

const Cases = () => {
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '4',
    spaceBetween: 35,
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
    navigation: {
      prevEl: '.slider-prev',
      nextEl: '.slider-next',
    },
  };
  return (
    <div className="it-cases-area p-relative z-index fix pt-120 pb-120">
      <div className="it-cases-shape-1 d-none d-lg-block">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="it-cases-title-wrap mb-70">
          <div className="row align-items-end">
            <div className="col-xl-8 col-lg-6 col-md-7">
              <div className="it-cases-left">
                <div className="it-cases-title-box">
                  <span className="it-section-subtitle green">
                    COMPLETED CASES
                  </span>
                  <h3 className="it-section-title">
                    Our Latest Successful <br /> Case Studies.
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-5">
              <div className="it-cases-arrow-box text-md-end">
                <button className="slider-prev">
                  <span>
                    <PrevArrowSVG />
                  </span>
                </button>
                <button className="slider-next">
                  <span>
                    <NextArrowSVG />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="it-cases-wrapper">
              <div className="swiper-container it-cases-active">
                <Swiper
                  modules={[Navigation]}
                  {...sliderOption}
                  className="swiper-wrapper"
                >
                  <SwiperSlide className="swiper-slide">
                    <SingleServiceFive
                      serviceImage={serviceImg1}
                      category="Depression"
                      title="Anxiety Disorder"
                      description="Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleServiceFive
                      serviceImage={serviceImg2}
                      category="Depression"
                      title="Anxiety Disorder"
                      description="Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleServiceFive
                      serviceImage={serviceImg3}
                      category="Depression"
                      title="Anxiety Disorder"
                      description="Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleServiceFive
                      serviceImage={serviceImg4}
                      category="Depression"
                      title="Anxiety Disorder"
                      description="Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleServiceFive
                      serviceImage={serviceImg2}
                      category="Depression"
                      title="Anxiety Disorder"
                      description="Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleServiceFive
                      serviceImage={serviceImg3}
                      category="Depression"
                      title="Anxiety Disorder"
                      description="Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt"
                    />
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cases;
